import { dehydrate, QueryClient, useQuery } from "@tanstack/react-query";
import type { GetServerSideProps, NextPage } from "next";
import { ESeoPage } from "@/utils/mockData/metaMocks";
import Seo from "@/components/common/Seo";
import AuthProvider from "@/components/common/AuthProvider";

import { withRedirect } from "@/utils/redirects";
import { getBrochureData, getNavBarData, getSeoInfo } from "../utils/queries";

import UserPageBody from "../components/account/userPage/UserPageBody";

const UserPage: NextPage = () => {
    const { data: metaTags } = useQuery({
        queryKey: ["metaTags"],
        queryFn: () => getSeoInfo(ESeoPage.USER),
    });

    return (
        <>
            <Seo seoInfo={metaTags!} />
            <AuthProvider>
                <UserPageBody />
            </AuthProvider>
        </>
    );
};

export const getServerSideProps: GetServerSideProps = withRedirect(async () => {
    const queryClient = new QueryClient();

    await Promise.all([
        await queryClient.prefetchQuery(["navBar"], getNavBarData),
        await queryClient.prefetchQuery(["brochures"], getBrochureData),
        await queryClient.prefetchQuery(["metaTags"], () =>
            getSeoInfo(ESeoPage.USER)
        ),
    ]);

    return {
        props: {
            dehydratedState: dehydrate(queryClient),
        },
    };
});

export default UserPage;
